import { toast } from "react-toastify";
import { Meta } from "../../../services/Meta";
import { useContextSite } from "../../../context/Context";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { IMetaDTO, IMetaForm, IMetaFormUpdate } from "../../../types/meta";

export const useGoalsEdite = () => {
  const { setIsLoad } = useContextSite();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const goalId = searchParams.get("uuid");
  const [meta, setMeta] = useState<IMetaDTO>({} as IMetaDTO);

  function handleSubmit(data: IMetaForm) {
    setIsLoad(true);

    const PAYLOAD: IMetaFormUpdate = {
      ...data,
      uuid: goalId,
    };

    return Meta.put(PAYLOAD)
      .then(() => {
        toast.success("Meta atualizada com sucesso");
        navigate("/configuracoes/metas");
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  function getGoalById(id: string) {
    setIsLoad(true);

    Meta.getById(id)
      .then(({ data }) => {
        setMeta(data);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => {
          toast.error(mensagem);
        }
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  useEffect(() => {
    if (goalId) getGoalById(goalId);
  }, [goalId]);

  return { handleSubmit, meta };
};
